import { connect } from 'react-redux';
import { organization } from '~/routes';
import MissingAccessPage from './components/MissingAccessPage';

export default connect(
  (state) => ({
    translations: state.i18n.translations['missing-access-page'],
  }),
  (dispatch) => ({
    switchOrganization(orgId) {
      dispatch(organization.goTo({ orgId }));
    },
  })
)(MissingAccessPage);
